// Chakra imports
import { Box, Portal, useDisclosure, Container as ChakraContainer } from '@chakra-ui/react';
// Layout components
import { useRef, useState } from 'react';
import Navbar from 'shared/components/horizon-ui/navbar/NavbarAdmin';
import Sidebar from 'shared/components/horizon-ui/sidebar/Sidebar';
import { SidebarContext } from 'shared/contexts/SidebarContext';
import useGetAllRoutes from 'shared/hooks/useGetAllRoutes';
import { GroupT } from 'shared/routes';
import FooterAuth from 'shared/components/horizon-ui/footer/FooterAuth';
import { Outlet, useLocation } from 'react-router-dom';
import { SIDEBAR_WIDTH } from "shared/utils/constants";

// Custom Chakra theme
export default function Dashboard(props: { [x: string]: FixMeLater }) {
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const groups = useGetAllRoutes(true);
  const navbarGroups = useGetAllRoutes();
  const location = useLocation();
  const containerRef = useRef();

  const getActiveRoute = (groups: GroupT[]): string => {
    const activeRoute = 'Default Brand Text';
    for (const group of groups) {
      for (const route of group.routes) {
        if (location.pathname === route.layout + route.path) {
          return (route.name ?? '') + '123';
        }
      }
    }
    return activeRoute + 'getActiveRoute';
  };

  const getActiveNavbar = (groups: GroupT[]): boolean => {
    const activeNavbar = false;
    for (const group of groups) {
      for (const route of group.routes) {
        if (window.location.href.includes(route.layout + route.path)) {
          return !!route.secondary;
        }
      }
    }
    return activeNavbar;
  };

  const getActiveNavbarText = (groups: GroupT[]): string | boolean => {
    const activeNavbar = false;
    for (const group of groups) {
      for (const route of group.routes) {
        if (window.location.href.includes(route.layout + route.path)) {
          return (route.name ?? '') + '123';
        }
      }
    }
    return activeNavbar + 'getActiveNavbarText';
  };

  const { onOpen } = useDisclosure();
  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar
        }}>
        <Sidebar groups={groups} display='none' {...props} />
        <Box
          float='right'
          minHeight='100vh'
          height='100%'
          overflow='auto'
          position='relative'
          maxHeight='100%'
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}
          w={{ base: '100%', xl: `calc( 100% - ${SIDEBAR_WIDTH}px )` }}
          maxWidth={{ base: '100%', xl: `calc( 100% - ${SIDEBAR_WIDTH}px )` }}
          transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
          transitionDuration='.2s, .2s, .35s'
          transitionProperty='top, bottom, width'
          transitionTimingFunction='linear, linear, ease'>
          <Portal containerRef={containerRef}>
            <Box>
              <Navbar
                onOpen={onOpen}
                logoText={'Horizon UI Dashboard PRO'}
                brandText={getActiveRoute(navbarGroups)}
                secondary={getActiveNavbar(navbarGroups)}
                message={getActiveNavbarText(navbarGroups)}
                fixed={fixed}
                {...props}
              />
            </Box>
          </Portal>

          <ChakraContainer maxW="1400px" marginX="unset" overflowX='hidden' position="relative" p={{ base: '20px' }} pe='20px' minH='calc(100vh - 34px)' ref={containerRef}>
            <Outlet />
          </ChakraContainer>
          <ChakraContainer maxW="1400px" marginX="unset">
            <FooterAuth isHideLogo />
          </ChakraContainer>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
